
import axios from '../plugins/axiosPlugins'
import runEvn from '../modular/runEvn/RunEvn'
const baseURL = runEvn().apiBaseUrl;
const api2BaseUrl = runEvn().api2BaseUrl;

/**
 * 个人中心
 * @returns 
 */
export const getUserInfo = (): any => {
    // @ts-ignore
    return axios.get(`${baseURL}/Users/GetUserInfo`, { apiCtrlConf: { closeDefaultHandle: true } })
}

/**
 * 个人中心
 * @returns 
 */
export const getUserInfo_v0 = (): any => {
    // @ts-ignore
    return axios.get(`${api2BaseUrl}/User/user`, { apiCtrlConf: { closeDefaultHandle: true } })
}



/**
 * 更新电话
 * @returns 
 */
export const updatePhone = (phone: string): any => {
    return axios.put(`${baseURL}/Users/updatePhone?phone=${phone}`)
}

/**
 * 更新昵称
 * @returns 
 */
export const updateNickName = (name: string): any => {
    return axios.put(`${baseURL}/Users/updateNickName?name=${name}`)
}

/**
 * 更新名称
 * @returns 
 */
export const updateName = (name: string): any => {
    return axios.put(`${baseURL}/Users/updateName?name=${name}`)
}

/**
 * 更新名称
 * @returns 
 */
export const updateSex = (sex: number): any => {
    return axios.put(`${baseURL}/Users/updateSex?sex=${sex}`)
}

/**
 * 更新名称
 * @returns 
 */
export const updateHeadUrl = (key: string): any => {
    return axios.put(`${baseURL}/Users/updateHeadUrl?key=${key}`)
}

/**
 * 添加用户
 * @param data 
 * @returns 
 */
export const AddUser = (data: any): any => {
    return axios.post(`${baseURL}/Users`, data);
}


/**
 * 添加用户
 * @param data 
 * @returns 
 */
export const logout = (): any => {
    return axios.get(`${api2BaseUrl}/user/User/LogOut`);
}

/**
 * 获取手机号验证码
 * @param data 
 * @returns 
 */
export const sendPhoneVerifCode = (data: any): any => {
    return axios.post(`${api2BaseUrl}/user/PhoneVerifCode`, data);
}

/**
 * 获取验证结果
 * @param params 
 * @returns 
 */
export const verifResult = (params: any): any => {
    return axios.get(`${api2BaseUrl}/user/PhoneVerifCode/VerifResult`, {params});
}

export const DictTypeItem = (params: any): any => {
    return axios.get(`${api2BaseUrl}/user/DictTypeItem`, {params});
}
